/**
 * 挂载到vue上的方法
 */
export default {
    install(Vue)  {
        /**
         * 返回数组中对应key的值
         * arrayTemp 格式 [
         *     {label:"", value:""}
         * ]
         */
        Vue.prototype.$arrayFomatter = function (val, arrayTemp){
            let str = "";
            for(let i=0, max = arrayTemp.length; i<max; i++){
                if(arrayTemp[i].value == val){
                    str = arrayTemp[i].label;
                    break;
                }
            }
            return str
        }
        // 判断对象是否为空
        Vue.prototype.$objIsEmpty = function(o) {
            return (typeof o === 'object' || typeof o === 'function') && o !== null && JSON.stringify(o) != "{}"
        },
        // 浮点相乘
        Vue.prototype.$accMul = function(arg1,arg2){ 
			var m=0,s1=arg1.toString(),s2=arg2.toString(); 
			try{m+=s1.split(".")[1].length}catch(e){} 
			try{m+=s2.split(".")[1].length}catch(e){} 
			return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m) 
        },
        // 为空情况
        Vue.prototype.$isEmpty = function(obj) { // 为空情况
            const empty_arr = ['', undefined, null];
            return (empty_arr.indexOf(obj) > -1 || obj.toString().trim() === '');
        }
        // 剔除数组中的空值
        Vue.prototype.$ArrayFilterParams = function(arr) { // 剔除数组中的空值
            var err = [];
            const empty_arr = ['', undefined, null];
            arr.forEach((item, index) => {
                if (this.$isEmpty(item)) return;
                err.push(
                    typeof item === 'object' ? (
                        item instanceof Array ? this.$ArrayFilterParams(item) :  this.$filterParams(item)
                    ) : item
                );
            })
            return err;
        }
        // 剔除对象的空属性
        Vue.prototype.$filterParams = function(obj) { // 剔除对象的空属性
            var _newObj = {};
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) { // 判断对象中是否有这个属性
                    if (this.$isEmpty(obj[key])) continue;
                    _newObj[key] = typeof obj[key] === 'object' ? (
                        obj[key] instanceof Array ? this.$ArrayFilterParams(obj[key]) : this.$filterParams(obj[key])
                    ): obj[key];
                }
            }
            return _newObj;
        }
    }
}